export const SUCCESS_PAGE_TEST_IDS = {
    TABLE_BOOKING_INFO: "table-booking-info",
    ACCORDION_ZERO_CONTAINER: "accordion-container-0",
    ACCORDION_ONE_CONTAINER: "accordion-container-1",
    DONE_BUTTON: "done-btn",
    VIEW_HELP_SECTION: "view-help",
    VIEW_HELP_BUTTON: "view-help-btn",
    BILL_ITEMS: "bill-items-1",
    BILL_TO_PAY: "billToPay",
    TABLE_BOOK: "table-book",
    DOWNLOAD_BTN: "download-btn",
    DINECASH_POOL_BANNER: "dinecash-pool-banner",
    CALLOUTS_BANNER: "callouts-banner",
    CALLOUTS_BANNER_CONTENT: "callouts-banner-content",
    CALLOUTS_BANNER_HALF_CARD: "callouts-banner-half-card",
    CELEBRATION_HALF_CARD: "celebration-half-card",
};

export const TIP_WIDGET_TEST_IDS = {
    CONTAINER: "tip-widget",
    TITLE: "tip-widget-title",
    SUBTITLE: "tip-widget-subtitle",
    CLOSE_BTN: "tip-widget-close",
    PAYMENT_OPTION: "tip-widget-payment-option",
    SINGLE_OPTION_CHEVRON: "tip-widget-single-option-chevron",
    TIP_CTA: "tip-widget-tip-cta",
};
